// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".lx-embedded-modal-textarea[data-v-78613356]{min-height:100px}.embedded-page-title-input[data-v-78613356]{padding:0 18px}.btn-html-code[data-v-78613356]{margin-left:18px !important}.embedded-page-settings-frame[data-v-78613356]{height:auto;min-height:600px;min-width:98%}.embedded-page-settings-property-frame[data-v-78613356]{min-width:98%;height:auto}", ""]);
// Exports
module.exports = exports;
